const state = {
	isNavOpen: null,
	isLoading: false,
}

const getters = {
	isNavOpen(currentState) {
		return currentState.isNavOpen
	},
	isLoading(currentState) {
		return currentState.isLoading
	},
}

const actions = {
	toggleNav({ commit }) {
		commit('toggleNav')
	},
	setNav({ commit }, value) {
		commit('setNav', value)
	},
	startLoading({ commit }) {
		commit('setLoading', true)
	},
	stopLoading({ commit }) {
		commit('setLoading', false)
	},
}

const mutations = {
	toggleNav(currentState) {
		currentState.isNavOpen = !currentState.isNavOpen
	},
	setNav(currentState, value) {
		currentState.isNavOpen = value
	},
	setLoading(currentState, value) {
		currentState.isLoading = value
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}
